export var MonthFormat={SHORT:"short",LONG:"long"};